<template>
  <div>
   <lk-form  :model='interviewTask' ref="interviewee" :rules='validate' :label-width='84'>
    <lk-row >
      <lk-col span='8'>
        <lk-form-item label='随访预约:'>
          <lk-radio-group v-model="interviewTask.isInterviewToo"  @on-change='setAdditionalRemark'>
            <lk-radio :label="2" :disabled="!isEdit">停止随访</lk-radio>
            <lk-radio :label="1" :disabled="!isEdit">继续随访</lk-radio>
          </lk-radio-group>
        </lk-form-item>
      </lk-col>
      <lk-col span='8'>
        <lk-form-item
          label='停止原因:'
          prop='reasonStop'
          :class="{'ivu-form-item-required':interviewTask.isInterviewToo == 2}"
        >
          <lk-select
            v-model='interviewTask.reasonStop'
            :disabled='isContinue || !isEdit'
            placeholder='请选择'
          >
            <lk-option v-for="(item, index) in stopList" :key="index" :value="item.name">{{item.name}}</lk-option>
          </lk-select>
        </lk-form-item>
      </lk-col>
    </lk-row>
    <lk-row>
      <lk-col span='8'>
        <lk-form-item label='被访人姓名:'>
          <lk-input  v-model="interviewTask.intervieweeName" :disabled="!isContinue || !isEdit"></lk-input>
        </lk-form-item>
      </lk-col>
      <lk-col span='8'>
        <lk-form-item label='被访人电话:' prop='phone'>
          <lk-input  v-model="interviewTask.phone" :disabled="!isContinue || !isEdit"></lk-input>
        </lk-form-item>
      </lk-col>
      <lk-col span='8'>
        <lk-form-item label='与用药人关系:'>
          <lk-select :transfer='true'
            v-model="interviewTask.relationship"
            placeholder='请选择关系'
            :disabled="!isContinue || !isEdit"
          >
            <lk-option v-for='(item,i) in contactRelationList' :key="i" :value='i*1'>
              {{item}}</lk-option>
          </lk-select>
        </lk-form-item>
      </lk-col>
    </lk-row>
    <lk-row v-if="isContinue">
      <lk-col span='8' >
        <lk-form-item label='预约新时间:'>
          <lk-radio-group v-model.trim="interviewTask.isImport">
            <lk-radio :label="2" :value="2" :disabled="!isContinue || !isEdit">从已经预约时间中选择</lk-radio>
            <lk-radio :label="1" :value="1" :disabled="!isContinue || !isEdit">新预约时间</lk-radio>
          </lk-radio-group>
        </lk-form-item>
      </lk-col>
      <lk-col span='8'>
         <lk-form-item label=''>
          <lk-select
            :transfer='true'
            filterable
            v-model="interviewTask.taskIdToMerge"
            placeholder='请输入或者选择任务编号'
            :disabled='!isContinue || interviewTask.isImport!=2 || !isEdit'
          >
            <lk-option v-for='(item,i) in taskIds' :key="i" :value='item*1'>{{item}}</lk-option>
          </lk-select>
        </lk-form-item>
      </lk-col>
    </lk-row>
    <lk-row v-if="interviewTask.isImport === 1">
      <lk-col span='8'>
        <lk-form-item label='随访时间1:'>
          <timeStampDatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :options="options"
            v-model="interviewTask.time1"
            clearable
            :disabled="!isEdit"
            style="width: 100%"
            placeholder="请选择"
          />
        </lk-form-item>
      </lk-col>
      <lk-col span='8'>
        <lk-form-item label='随访时间2:'>
          <timeStampDatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :options="options"
            v-model="interviewTask.time2"
            clearable
            style="width: 100%"
            placeholder="请选择"
            :disabled='dateTime2Diabled'
          />
        </lk-form-item>
      </lk-col>
      <lk-col span='8'>
        <lk-form-item label='随访时间3:'>
          <timeStampDatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :options="options"
            v-model="interviewTask.time3"
            clearable
            style="width: 100%"
            placeholder="请选择"
            :disabled='dateTime3Diabled'
          />
        </lk-form-item>
      </lk-col>
    </lk-row>
  </lk-form>
</div>
</template>
<script>
import utils from '../../libs/utils';

export default {
  name: 'Interviewee',
  components: {
  },
  props: {
    isEdit: {
      type: Boolean,
    },
    isHaveNext: {
      type: Boolean,
    },
    value: {
      type: Object,
    },
    taskIds: {
      type: Array,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    isContinue() {
      return this.interviewTask.isInterviewToo == 1;
    },
    dateTime2Diabled() {
      const currentTime = new Date().getTime();
      return !this.isEdit || !this.interviewTask.time1 || this.interviewTask.time1 < currentTime;
    },
    dateTime3Diabled() {
      const currentTime = new Date().getTime();
      return !this.isEdit || !this.interviewTask.time2 || this.interviewTask.time2 < currentTime || this.interviewTask.time2 < this.interviewTask.time1;
    },
  },
  watch: {
    value: {
      handler() {
        const result = {};
        if (!this.value.phone && this.value.patientPhone) {
          this.$set(result, 'phone', this.value.patientPhone);
          this.$set(result, 'intervieweeName', this.value.patientName);
          this.interviewTask = result;
        } else {
          this.interviewTask = this.value;
        }
        !this.value.relationship
          ? this.$set(this.interviewTask, 'relationship', 1)
          : null;
        if (!this.isEdit && this.interviewTask.time1) {
          this.$set(this.interviewTask, 'isImport', 1);
        }
      },
      deep: true,
    },
    interviewTask: {
      handler(val) {
        if (this.isEdit) {
          if (this.interviewTask.isInterviewToo == 1) {
            this.$set(this.interviewTask, 'reasonStop', '');
          } else {
            this.$set(this.interviewTask, 'isImport', '');
            this.$set(this.interviewTask, 'time1', '');
            this.$set(this.interviewTask, 'time2', '');
            this.$set(this.interviewTask, 'time3', '');
            this.$set(this.interviewTask, 'taskIdToMerge', '');
          }
          if (this.interviewTask.isImport == 2) {
            this.$set(this.interviewTask, 'time1', '');
            this.$set(this.interviewTask, 'time2', '');
            this.$set(this.interviewTask, 'time3', '');
          } else {
            this.$set(this.interviewTask, 'taskIdToMerge', '');
          }
          const currentTime = new Date().getTime();
          if (val.time1) {
            if (val.time1 < currentTime) {
              this.$Message.error('所选时间不能小于当前时间');
            }
          } else {
            this.$set(this.interviewTask, 'time2', '');
            this.$set(this.interviewTask, 'time3', '');
          }
          if (val.time2) {
            if (val.time2 <= val.time1) {
              this.$Message.error('所选时间不能小于时间1');
            }
          } else {
            this.$set(this.interviewTask, 'time3', '');
          }
          if (val.time3 && val.time3 <= val.time2) {
            this.$Message.error('所选时间不能小于时间2');
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      interviewTask: {},
      valid2: false,
      validate: {
        phone: [{ validator: utils.validate.phoneValidator, trigger: 'blur' }],
        reasonStop: [{ required: false, message: '请选择暂停原因', trigger: 'change' }],
      },
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      stopList: [
        {
          id: 1,
          name: '患者去世',
        },
        {
          id: 2,
          name: '停止用药',
        },
        {
          id: 3,
          name: '更换用药',
        },
        {
          id: 4,
          name: '更换购药渠道',
        },
        {
          id: 5,
          name: '其他',
        },
      ],
      contactRelationList: {
        1: '患者本人',
        2: '患者配偶',
        3: '患者子女',
        4: '患者家属',
        5: '其他',
      },
    };
  },
  methods: {
    setAdditionalRemark() {
      if (this.interviewTask.isInterviewToo == 2) {
        this.validate.reasonStop = [{ required: true, message: '请选择暂停原因', trigger: 'change' }];
      } else {
        this.validate.reasonStop = [{ required: false }];
        this.$nextTick(() => {
          this.$refs.interviewee.validateField('reasonStop', () => {});
        });
      }
    },
    validaForm() {
      this.$emit('change', this.interviewTask);
      return new Promise((resolve) => {
        this.$refs.interviewee.validate((valid) => {
          const {
            time1, time2, time3, isInterviewToo, reasonStop, isImport, taskIdToMerge,
          } = this.interviewTask;
          if (this.isEdit) { // 如果随访都未接通，不用校验
            if (!isInterviewToo || (isInterviewToo === 1 && !isImport)) {
              this.$Message.error('请完善「用药指导和随访预约」');
              this.valid2 = false;
            } else if (isInterviewToo == 2 && !reasonStop) {
              this.$Message.error('请选择停止原因');
              this.valid2 = false;
            } else if (isImport == 1 && isInterviewToo == 1) {
              if (!time1 && !time2 && !time3) {
                this.$Message.error('请至少填写一个预约时间');
                this.valid2 = false;
              } else {
                const currentTime = new Date().getTime();
                if ((time1 && time1 < currentTime) || (time2 && time2 < currentTime) || (time3 && time3 < currentTime)) {
                  this.$Message.error('所选时间不能小于当前时间');
                  this.valid2 = false;
                } else {
                  this.valid2 = true;
                }
              }
            } else if (isImport == 2 && isInterviewToo == 1 && !taskIdToMerge) {
              this.$Message.error('请选择任务编号');
              this.valid2 = false;
            } else {
              this.valid2 = true;
            }
          } else {
            this.valid2 = true;
          }
          resolve(this.valid2 && valid);
        });
      });
    },
  },
  created() {
  },

};
</script>
<style lang="less" scoped>
</style>
